(function () {

  const sliders = document.querySelectorAll('.depth-slider');
  if (!sliders.length) return;

  sliders.forEach((slider) => {

    const slides = Array.from(slider.querySelectorAll('.depth-slide'));
    const sliderWrapper = slider.closest('.slider-wrapper');

    const dots = sliderWrapper.querySelectorAll('.depth-dot');
    if (!slides.length) return;

    let index = Math.floor(slides.length / 2);
    let timer = null;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    const swipeThreshold = 50; // minimum px to trigger swipe

    /* SLIDE POSITIONING */
    function updateSlides() {
      const total = slides.length;

      slides.forEach((slide, i) => {
        slide.classList.remove(
          'is-center',
          'is-left',
          'is-right',
          'is-far-left',
          'is-far-right'
        );

        const diff = (i - index + total) % total;

        if (diff === 0) slide.classList.add('is-center');
        else if (diff === 1) slide.classList.add('is-right');
        else if (diff === 2) slide.classList.add('is-far-right');
        else if (diff === total - 1) slide.classList.add('is-left');
        else if (diff === total - 2) slide.classList.add('is-far-left');
      });

      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    /* AUTO SLIDE */
    function startAuto() {
      timer = setInterval(() => {
        index = (index + 1) % slides.length;
        updateSlides();
      }, 3000);
    }

    function resetAuto() {
      clearInterval(timer);
      // startAuto();
    }

    /* SWIPE LOGIC */
    function handleSwipe() {
      const diff = startX - currentX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // swipe left → next
          index = (index + 1) % slides.length;
        } else {
          // swipe right → previous
          index = (index - 1 + slides.length) % slides.length;
        }

        updateSlides();
        resetAuto();
      }
    }

    /* TOUCH EVENTS (Mobile) */
    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    slider.addEventListener('touchend', () => {
      if (!isDragging) return;
      handleSwipe();
      isDragging = false;
    });

    /* MOUSE EVENTS (Desktop Drag) */
    slider.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      slider.style.cursor = "grabbing";
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX;
    });

    slider.addEventListener('mouseup', () => {
      if (!isDragging) return;
      handleSwipe();
      isDragging = false;
      slider.style.cursor = "grab";
    });

    slider.addEventListener('mouseleave', () => {
      isDragging = false;
      slider.style.cursor = "grab";
    });

    //     let isScrolling = false;

    // slider.addEventListener("wheel", (e) => {
    //   if (isScrolling) return;

    //   // detect horizontal touchpad swipe
    //   if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
    //     console.log(e.deltaX);
    //     console.log(e.deltaY);
    //     isScrolling = true;

    //     if (e.deltaX > 10) {
    //         console.log(e.deltaX);
    //       index = (index + 1) % slides.length;
    //     } else if (e.deltaX < -10) {
    //       index = (index - 1 + slides.length) % slides.length;
    //     }

    //     updateSlides();
    //     resetAuto();

    //     setTimeout(() => {
    //       isScrolling = false;
    //     }, 500);
    //   }
    // }, { passive: true });

 let isAnimating = false;
let lastDirection = 0;
const wheelThreshold = 40;

slider.addEventListener("wheel", (e) => {
  const horizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
  if (!horizontal || isAnimating) return;

  const direction = e.deltaX > 0 ? 1 : -1;

  // prevent multiple triggers in same momentum direction
  if (direction === lastDirection) return;

  if (Math.abs(e.deltaX) > wheelThreshold) {
    isAnimating = true;
    lastDirection = direction;

    if (direction === 1) {
      index = (index + 1) % slides.length;
    } else {
      index = (index - 1 + slides.length) % slides.length;
    }

    updateSlides();
    resetAuto();

    setTimeout(() => {
      isAnimating = false;
      lastDirection = 0; 
    }, 450); 
  }

}, { passive: true });

    /* CLICK SUPPORT (Keep Existing) */
    slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        if (slide.classList.contains('is-center')) return;

        if (slide.classList.contains('is-right'))
          index = (index + 1) % slides.length;
        else if (slide.classList.contains('is-far-right'))
          index = (index + 2) % slides.length;
        else if (slide.classList.contains('is-left'))
          index = (index - 1 + slides.length) % slides.length;
        else if (slide.classList.contains('is-far-left'))
          index = (index - 2 + slides.length) % slides.length;

        updateSlides();
        resetAuto();
      });
    });

    if (dots.length) {
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          index = parseInt(dot.dataset.index);
          updateSlides();
          resetAuto();
        });
      });
    }

    /* INIT */
    updateSlides();
    // startAuto();
  });

})();